// src/pages/feed/components/FeedExplore.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import PostagemCard from "./PostagemCard";
import { PostagemDTO } from "../types";
import styles from "./styles/Feed.module.css";

const FeedExplore: React.FC = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Inicializa filtros a partir da URL
  const pacoteIdParam = searchParams.get("pacoteId");
  const pontoNomeParam = searchParams.get("pontoNome");

  const [pacoteId] = useState<number | undefined>(
    pacoteIdParam ? Number(pacoteIdParam) : undefined
  );
  const [pontoNome, setPontoNome] = useState<string>(pontoNomeParam || "");
  const [postagens, setPostagens] = useState<PostagemDTO[]>([]);
  const [pagina, setPagina] = useState(0);
  const [tamanho] = useState(10);
  const [carregando, setCarregando] = useState(false);

  // Busca inicial (sem filtros ou com pacote vindo da URL)
  useEffect(() => {
    fetchFeed(0);
  }, [pacoteId]);

  const fetchFeed = async (paginaAtual: number) => {
    setCarregando(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get<PostagemDTO[]>(`${BASE_URL}/feed/filtro`, {
        params: { pacoteId, pontoNome, pagina: paginaAtual, tamanho },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      if (paginaAtual === 0) {
        setPostagens(res.data);
      } else {
        setPostagens((prev) => [...prev, ...res.data]);
      }
    } catch (error) {
      console.error("Erro ao carregar feed:", error);
    } finally {
      setCarregando(false);
    }
  };

  const handleBuscar = () => {
    const query = new URLSearchParams();
    if (pacoteId) query.set("pacoteId", String(pacoteId));
    if (pontoNome) query.set("pontoNome", pontoNome);
    navigate(`${window.location.pathname}?${query.toString()}`, { replace: true });

    setPagina(0);
    fetchFeed(0);
  };

  const handleCurtir = async (postagemId: number) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return alert("Você precisa estar logado para curtir.");

      await axios.post(
        `${BASE_URL}/postagens/${postagemId}/curtir`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPostagens((prev) =>
        prev.map((p) =>
          p.id === postagemId
            ? {
              ...p,
              jaCurtiu: !p.jaCurtiu,
              totalCurtidas: p.jaCurtiu
                ? p.totalCurtidas - 1
                : p.totalCurtidas + 1,
            }
            : p
        )
      );
    } catch (error) {
      console.error("Erro ao curtir postagem:", error);
    }
  };

  const carregarMais = () => {
    const proximaPagina = pagina + 1;
    setPagina(proximaPagina);
    fetchFeed(proximaPagina);
  };

  return (
    <div className={styles.feedContainer}>
      <div className={styles.filterContainer}>
        {/* Input e botão lado a lado */}
        <div className={styles.inputButtonWrapper}>
          <input
            type="text"
            placeholder="Filtrar por ponto de interesse"
            value={pontoNome}
            onChange={(e) => setPontoNome(e.target.value)}
            className={styles.filterInput}
          />
          <button onClick={handleBuscar} className={styles.searchButton}>
            Buscar
          </button>
        </div>

        {/* Texto informativo abaixo, centralizado */}
        <div className={styles.searchInfo}>
          {pontoNome
            ? `Buscando postagens relacionadas ao ponto "${pontoNome}".`
            : pacoteId && postagens.length > 0
              ? `Buscando postagens do pacote "${postagens[0].pacoteTitulo}".`
              : "Exibindo postagens mais curtidas da última semana."}
        </div>
      </div>

      {postagens.map((post) => (
        <PostagemCard key={post.id} postagem={post} onCurtir={handleCurtir} />
      ))}

      {carregando && (
        <div className={styles.loaderContainer}>
          <div className={styles.loader}></div>
        </div>
      )}

      {!carregando && postagens.length > 0 && (
        <div className={styles.buttonWrapper}>
          <button onClick={carregarMais} className={styles.loadMoreBtn}>
            Ver mais
          </button>
        </div>
      )}
    </div>
  );
};

export default FeedExplore;